import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classes from './products.module.scss';
import { useQuery } from '../../../utils/hooks/useQuery';
import { getProductsRequest } from '../../../store/actions/products';
import { changeMenuPath } from '../../../store/actions/menu';
import Utils from '../../../utils/utils';
import Button from '../../_common/Form/Buttons/Button';
import InputField from '../../_common/Form/TextFields/InputField';
import Loader from '../../_common/Loader/Loader';
import ProductsTable from './ProductsTable/ProductsTable';
import Checkbox from '../../_common/Form/Checkbox/Checkbox';

let timeout;

const Products = () => {
  const { pathname } = useLocation();

  const { query, setQuery, queryToStringify } = useQuery();

  const dispatch = useDispatch();
  const {
    productList,
    productTotalPage,
  } = useSelector((store) => store.products);

  const [requestData, setRequestData] = useState({
    search: query.search || '',
    page: query.page || 1,
    limit: query.limit || 15,
    otc: query.otc || 0,
    sortBy: query.sortBy || 'name',
    sort: query.sort || 'asc',
  });
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const {
    page, limit, search, otc, sort, sortBy,
  } = requestData;

  useEffect(() => {
    (async () => {
      const data = Utils.deleteEmptyKeys({ ...requestData });

      await dispatch(getProductsRequest(data));

      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    dispatch(changeMenuPath('Products', `${pathname}${queryToStringify(query)}`));
  }, [query]);

  const onChangePageData = async (path, count) => {
    const data = Utils.deleteEmptyKeys({
      ...requestData,
      [path]: count,
    });

    if (data.otc === undefined) {
      data.otc = 0;
    }

    if (path === 'limit') {
      data.page = 1;
    }

    await dispatch(getProductsRequest(data));

    setRequestData(data);

    setQuery(data);
  };

  const onSortBy = async (newSort) => {
    const data = Utils.deleteEmptyKeys({
      ...requestData,
      ...newSort,
      page: 1,
    });

    if (data.otc === undefined) {
      data.otc = 0;
    }

    setTableLoading(true);

    await dispatch(getProductsRequest(data));

    setTableLoading(false);

    setRequestData(data);

    setQuery(data);
  };

  const changeSearch = async (value) => {
    setLoading(true);
    setRequestData((prev) => ({
      ...prev,
      page: 1,
      search: value,
    }));

    if (value.trim()) {
      clearTimeout(timeout);

      timeout = setTimeout(async () => {
        await dispatch(getProductsRequest({
          ...requestData,
          page: 1,
          search: value,
        }));
      }, 400);
    } else {
      const data = Utils.deleteEmptyKeys({
        ...requestData,
        page: 1,
        search: '',
      });

      if (data.otc === undefined) {
        data.otc = 0;
      }

      await dispatch(getProductsRequest(data));
    }

    setLoading(false);

    setQuery({
      ...requestData,
      page: 1,
      search: value,
    });
  };

  const clearSearch = async () => {
    const data = Utils.deleteEmptyKeys({
      ...requestData,
      page: 1,
      search: '',
    });

    if (data.otc === undefined) {
      data.otc = 0;
    }

    setLoading(true);

    setRequestData((prev) => ({
      ...prev,
      page: 1,
      search: '',
    }));

    await dispatch(getProductsRequest(data));

    setLoading(false);

    setQuery({
      ...requestData,
      page: 1,
      search: '',
    });
  };

  const checkOTC = async (checked) => {
    setLoading(true);

    const data = Utils.deleteEmptyKeys({
      ...requestData,
      page: 1,
      otc: +checked,
    });

    if (data.otc === undefined) {
      data.otc = 0;
    }

    setRequestData(data);

    setQuery({
      ...requestData,
      otc: +checked,
    });
    await dispatch(getProductsRequest(data));

    setLoading(false);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <h2>Products</h2>

        <div className={classes.header_btn}>
          <Checkbox
            onChange={(checked) => checkOTC(checked)}
            className={classes.checkbox}
            checked={!!otc}
            label="OTC"
          />

          <Button
            href="add"
            title="Add new product"
            type="button"
            className={classes.btn}
            addButton
            reverseColor
          />

          <Button
            href="/products/order"
            title="Order"
            type="button"
            className={classes.btn}
          />

          {/* <Button */}
          {/*  href="/products/adjust" */}
          {/*  title="Adjust" */}
          {/*  type="button" */}
          {/*  className={classes.btn} */}
          {/* /> */}
        </div>
      </div>

      <div className={classes.search_block}>
        <div className={classes.search}>
          <InputField
            wrapperClassName={classes.search_field}
            label="Search"
            value={search}
            onChange={(value) => changeSearch(value)}
          />

          <Button
            onClick={clearSearch}
            title="Clear"
            type="button"
            clearButton
            className={classes.btn}
          />
        </div>

        {/* <Button */}
        {/*  onClick={() => {}} */}
        {/*  title="Assign to Me" */}
        {/*  type="button" */}
        {/*  reverseColor */}
        {/*  className={classes.btn} */}
        {/* /> */}
      </div>

      {loading
        ? <Loader className={classes.loader} />

        : (
          <ProductsTable
            data={productList}
            onChange={onChangePageData}
            totalPage={productTotalPage}
            limit={+limit}
            page={+page - 1}
            otc={otc}
            sort={sort}
            sortBy={sortBy}
            onSortBy={onSortBy}
            loading={tableLoading}
          />
        )}
    </div>
  );
};
export default Products;
